<template>
  <div class="fe-calendar">
    <client-only>
      <my-calendar
        ref="calendarComponent"
        :mark-date="markDates"
        :sunday-start="true"
        :text-top="textTop"
        @changeMonth="changeMonth"
      />
    </client-only>
  </div>
</template>

<script>
import { getCalendar } from '@/api/desktop/calendar'
import dayjs from 'dayjs'

import { hk6YearRange, updateView } from '@/utils/commonLib'

export default {
  data() {
    return {
      markDates: [],
      textTop: ['日', '一', '二', '三', '四', '五', '六'],
      minDate: '',
      maxDate: '',
      calendarEl: null
    }
  },
  computed: {
    minYear() {
      return hk6YearRange()[hk6YearRange().length - 1] // 最早的年份
    }
  },
  async mounted() {
    this.minDate = `${this.minYear}-01-01`
    // 香港六合彩會預先爬未來3期，要多一個月查詢
    this.maxDate = dayjs().add(1, 'month').endOf('month').format('YYYY-MM-DD')

    const today = dayjs()
    await this.getCalendar(today.format('YYYY-MM'))

    this.$nextTick(() => {
      this.calendarEl = this.$refs.calendarComponent
      if (this.calendarEl) {
        updateView(this, today)
      }
    })
  },
  methods: {
    async getCalendar(date) {
      const [data, err] = await getCalendar(date)
      if (err) {
        console.error(`[error]:`, err)
        return
      }
      this.markDates = data
    },
    async changeMonth(dateStr) {
      // date format is YYYY/M
      const date = dayjs(dateStr, 'YYYY/M')
      await this.getCalendar(date.format('YYYY-MM'))

      this.$nextTick(() => {
        updateView(this, date)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fe-calendar {
  & /deep/ {
    .wh_container {
      background-color: #ffffff;
      max-width: 410px;
      .wh_content_all {
        background-color: #ffffff;
        .wh_top_changge {
          margin: 10px 0;
          .disabled {
            pointer-events: none;
            opacity: 0.1;
          }
          .wh_jiantou1 {
            width: 12px;
            height: 12px;
            border-top: 2px solid black !important;
            border-left: 2px solid black !important;
          }
          .wh_jiantou2 {
            width: 12px;
            height: 12px;
            border-top: 2px solid black !important;
            border-right: 2px solid black !important;
          }
          .wh_content_li {
            color: black;
            font-family: "PingFang SC", "Apple LiGothic Medium", "Droid Sans", "Microsoft YaHei", "Microsoft JhengHei", "Helvetica Neue", Helvetica, sans-serif;
            line-height: 16px;
            font-size: 16px;
            font-weight: 500;

          }
        }
        .wh_content {
          &:nth-child(2) {
            .wh_content_item:nth-child(7) {
              color:red;
            }
            .wh_content_item:nth-child(1) {
              color:red;
            }
          }
          .wh_content_item {
            color: black;
            .wh_top_tag {
              font-size: 0.875rem;
              line-height: 0.875rem;
            }
            .wh_item_date {
              width: 2rem;
              height: 2rem;
              position: relative;
              top:50%;
              transform:translateY(-50%);
              align-items: center;
              font-size: 0.875rem;
              line-height: 0.875rem;
              font-weight: 400;
              &:hover {
              background-color: #e0e0e0;
              border-radius: 50%;
              min-width: 2rem;
              line-height: 2rem;
              min-height: 2rem;
              text-align: center;
            }
            }
            .wh_isToday {
              background-color: transparent;
              background-color: #F0F0F0!important;
              color: #000000;
              min-width: 2rem;
              text-align: center;
              line-height: 2rem;
              min-height: 2rem;
              border-radius: 50%;
            }
            .wh_other_dayhide {
              color: #adadad;
            }
            .wh_isMark {
              background-color: #178AFF!important;
              color: #ffffff;
              min-width: 0.5rem;
              text-align: center;
              line-height: 0.5rem;
              min-height: 0.5rem;
              border-radius: 50%;
              font-weight: 100;
            }
            .wh_chose_day {
              background-color: transparent;
            }
            &.disabled {
              pointer-events: none;
              user-select: none;
              .wh_other_dayhide {
                color: #eeeeee;
              }
            }
          }
        }
      }
    }
  }
}
</style>
